export const isEmpty = (list: any[]) => {
  return list == null || list.length === 0;
};
